export const getObjectFitSize = (
  containerWidth,
  containerHeight,
  width,
  height,
  left,
  top
) => {
  let naturalRatio = width / height
  let containerRatio = containerWidth / containerHeight
  let targetWidth = 0
  let targetHeight = 0
  let test = naturalRatio > containerRatio

  if (test) {
    targetWidth = containerWidth
    targetHeight = targetWidth / naturalRatio
  } else {
    targetHeight = containerHeight
    targetWidth = targetHeight * naturalRatio
  }

  return {
    width: targetWidth,
    height: targetHeight,
    x: (containerWidth - targetWidth) / 2 + left,
    y: (containerHeight - targetHeight) / 2 + top,
  }
}
